import type { IntegratedOrder, IntegratedOrderAction, IntegratedOrderStatusFilter } from "@/lib/api";

export const INTEGRATED_ORDER_STATUS_OPTIONS: { value: IntegratedOrderStatusFilter; label: string }[] = [
  { value: "all", label: "Todas as situações" },
  { value: "review", label: "Em revisão" },
  { value: "valid", label: "Válidos" },
  { value: "routed", label: "Roteados ao programado" },
  { value: "not_routed", label: "Válidos sem roteamento" },
];

export const INTEGRATION_TYPE_LABELS: Record<number, string> = {
  1: "Conta na bonificação",
  0: "Ignorado na bonificação",
};

const ROUTED_CATEGORY_LABELS: Record<string, string> = {
  second_semester: "Programado 2º semestre",
  exam: "Programado avaliação/simulado",
};

const ACTION_LABELS: Record<IntegratedOrderAction, string> = {
  bonus_counted: "Contou na bonificação",
  scheduled_created: "Criou pedido programado",
  scheduled_updated: "Atualizou pedido programado",
  integrated_only: "Apenas integrado",
};

export const integratedOrderActionLabel = (action?: IntegratedOrderAction | null) =>
  action ? ACTION_LABELS[action] ?? action : null;

export const routedCategoryLabel = (category?: string | null) =>
  category ? ROUTED_CATEGORY_LABELS[category] ?? category : null;

export type IntegratedOrderSituation = "review" | "routed" | "valid";

export const integratedOrderSituation = (order: Pick<IntegratedOrder, "needsReview" | "routedCategory">): IntegratedOrderSituation =>
  order.needsReview ? "review" : order.routedCategory ? "routed" : "valid";

export const INTEGRATED_ORDER_SITUATION_LABELS: Record<IntegratedOrderSituation, string> = {
  review: "Em revisão",
  routed: "Roteado",
  valid: "Válido",
};

/** Mensagem devolvida pela API (`{ message }`) ou o texto padrão. */
export const integratedOrderErrorMessage = (error: unknown) =>
  (error as { response?: { data?: { message?: string } } })?.response?.data?.message
  ?? "Não foi possível concluir a operação.";

export const formatIntegratedOrderDate = (value?: string | null) => {
  if (!value) return "—";
  // A API devolve instantes UTC sem sufixo de fuso em alguns campos; sem "Z" o JS leria como horário local.
  const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`;
  return new Date(normalized).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
};

/** Total de páginas da listagem (mínimo 1). */
export const integratedOrderPageCount = (total: number, pageSize: number) =>
  Math.max(1, Math.ceil(total / Math.max(pageSize, 1)));
